import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { SUB_VIEW_MODEL } from '../../Model/Models';
import { permissionObj } from '../../../../../Helpers/permission';
import { GetColorFoodie } from '../../../../../reduxToolkit/Foodie/FoodieApi';
import { ATTENDANCE_MODES, MODEL_COLOR } from '../Models/Model';
import { MODELS } from '../../../../../Apis/Models';
import { TABLES } from '../../../../../Apis/Tables';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param useState setSubView: for set value
 */
const ManageApp = ({ setSubView, setSearchElement, setFinalArray, setSelectedOption, setModuleId, setOption, setBodyForExport,
                       setCriteria, setSearch }) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [color, setColor] = useState({ ...MODEL_COLOR });

    useEffect(() => {
         if (DEV || permission?.includes(permissionObj?.WEB_FOODIE_ATTENDANCE_READ)) {
            setSubView(SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE);
             return;
        }

        if (DEV || permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_READ)) {
            setSubView(SUB_VIEW_MODEL.MANAGE.DEPARTMENT_POLICIES);
            return;
        }
        if (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_READ)) {
            setSubView(SUB_VIEW_MODEL.MANAGE.SETTINGS);
            return;
        }

        if (DEV || permission?.includes(permissionObj?.WEB_TOTAL_MEALS_READ)) {
            setSubView(SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS);
            return;
        }

    }, [ permission]);

    useEffect(() => {
        dispatch(GetColorFoodie()).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                setColor({ ...MODEL_COLOR, ...data });
            },
        );
    }, []);

    /**
     * Function for the Dinning button.
     */
    const handleBtnDinning = () => {
        setSelectedOption(ATTENDANCE_MODES.daily);
        setSubView(SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE);
        setModuleId(MODELS.FOODIE);
        setOption(TABLES.FOODIE);
        reset();
    };

    /**
     * Function for the Department button.
     */
    const handleBtnSettings = () => {
        setSelectedOption(ATTENDANCE_MODES.daily);
        setSubView(SUB_VIEW_MODEL.MANAGE.SETTINGS);
        setModuleId(null);
        setOption(null);
        reset();
    };
    /**
     * Function for the Department button.
     */
    const handleBtnDepartmentPolicies = () => {
        setSelectedOption(ATTENDANCE_MODES.daily);
        setSubView(SUB_VIEW_MODEL.MANAGE.DEPARTMENT_POLICIES);
        setModuleId(null);
        setOption(null);
        reset();
    };

    /**
     * Function for the Dinning button.
     */
    const handleBtnTotalMeals = () => {
        setSelectedOption(ATTENDANCE_MODES.daily);
        setSubView(SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS);
        setModuleId(MODELS.TOTAL_MEALS);
        setOption(TABLES.FOODIE_MENU_TOTAL_MEALS);
        reset();
    };

    const reset = () => {
        setSearchElement('');
        setFinalArray([]);
        setBodyForExport(null);
        setCriteria(null);
        setSearch(false);
    };

    return {
        DEV,
        permission,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        color,
        setColor,
    };
};

export default ManageApp;
